module.exports = __webpack_public_path__ + "media/loan_payments_calculator/iFrame_widget-7685e89e.png";